import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class LMVZButton extends TKCustomElementFactory {
    constructor() {
        super();
    }

    connectedCallback() {
        this.regsiterButtonClick();
    }

    // #region button click handling
    regsiterButtonClick() {
        const buttonCLickHandler = this.onButtonClick.bind(this);

        this.pushListener({
            event: 'click',
            element: this,
            action: buttonCLickHandler,
        });
    }

    onButtonClick() {
        console.log('test');
    }
    // #endregion button click handling
}
